import React from 'react';
import { Inbox } from 'lucide-react';

export default function EmptyState({ icon: Icon = Inbox, title = 'No data yet', description, action, testId = 'empty-state' }) {
  return (
    <div className="text-center py-16 px-6" data-testid={testId}>
      <div className="w-12 h-12 mx-auto rounded-full bg-zinc-100 grid place-items-center mb-4">
        <Icon className="w-5 h-5 text-zinc-400" strokeWidth={1.75} />
      </div>
      <div className="font-display text-lg font-semibold text-zinc-900">{title}</div>
      {description && <p className="text-sm text-zinc-500 mt-1 max-w-sm mx-auto">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
